import { formatDynamicColumnName, serialize } from '@/services/UtilityService';
import ApiFactory from '@/factories/ApiFactory';
import ExportService from '@/services/ExportService';

const salesByItem = (filters) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`posweb/v1/reports/sales-by-item?${serialize(filters)}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getDynamicReportsCategories = () => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`posweb/v1/dynamic-reports-categories`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const getDynamicReportById = (id, filter) => {
	return new Promise((resolve, reject) => {
		ApiFactory.get(`reports/v1/pos/${id}?${serialize(filter)}`).then(
			({ data }) => {
				resolve(data.data);
			},
			(error) => reject(error)
		);
	});
};

const exportTable = (columns, data, fileTitle = 'Dynamic Report') => {
	return new Promise((resolve, reject) => {
		const tableData = data.map((table) => {
			const row = {};
			columns.forEach((column, index) => {
				const formattedColumnName = formatDynamicColumnName(column.name);
				row[formattedColumnName] = table[index] && table[index].value !== undefined ? table[index].value : '';
			});
			return row;
		});
		ExportService.export(tableData, fileTitle, 'true').then(resolve, reject);
	});
};

export default {
	salesByItem,
	getDynamicReportsCategories,
	getDynamicReportById,
	exportTable,
};
